import { Moment } from "moment"
import * as util from "lib/util"
import * as dateFilter from "enums/dateFilter"
import * as timePeriod from "enums/timePeriod"
import { TimePeriodTag } from "enums/timePeriod"

export function DeserializeDateFilter(
	val: string,
	fmt = "YYYY-MM-DD",
	delimiter = ":"
): dateFilter.DateFilter {
	const parts = val.Split(delimiter)

	const dfTag = parts.First().Expect("should have type")
	if (!dateFilter.IsDateFilterTag(dfTag)) {
		log.Fatalf("invalid tag recieved when parsing date filter %s", dfTag)
	}

	return dfTag.Match({
		AllTime: () => dateFilter.AllTime(),
		SingleDate: () =>
			dateFilter.SingleDate(util.Moment(parts.Get(1).Expect("no date provided"), fmt)),
		Range: () =>
			dateFilter.Range([
				util.Moment(parts.Get(1).Expect("no start date"), fmt),
				util.Moment(parts.Get(2).Expect("no end date"), fmt),
			]),
		Relative: () => {
			const tpFromVal = parts.Get(1).Expect("no time period provided") as TimePeriodTag
			const tp = timePeriod.TimePeriods.Parse(tpFromVal).Expect("No time period found")
			return dateFilter.Relative({
				unit: tp,
				count: parseInt(parts.Get(2).Expect("no count provided")),
			})
		},
	})
}

export function GetCurrentDate(): Date {
	return util.Moment().endOf("day").toDate()
}

export function FmtDateRange(start: Moment, end: Moment, format = "MMM D, YYYY"): string {
	return `${start.format(format)} - ${end.format(format)}`
}

export function CreateDateRange(
	d1: Moment,
	d2: Moment,
	granularity: Lowercase<TimePeriodTag> = "day"
): [Moment, Moment] {
	// will return a tuple of two moments. The first moment will be the earlier date
	return [d1.isBefore(d2, granularity) ? d1 : d2, d1.isBefore(d2, granularity) ? d2 : d1]
}

export function SerializeDateFilter(
	df: dateFilter.DateFilter,
	fmt = "YYYY-MM-DD",
	delimiter = ":"
): string {
	return df.Match({
		AllTime: () => df.Tag,
		SingleDate: (date) => `${df.Tag}${delimiter}${date.format(fmt)}`,
		Range: ([start, end]) =>
			`${df.Tag}${delimiter}${start.format(fmt)}${delimiter}${end.format(fmt)}`,
		Relative: ({ unit, count }) => `${df.Tag}${delimiter}${unit.Tag}${delimiter}${count}`,
	})
}

export const Custom = "Custom"
export const AllTime = "AllTime"
